import 'aem-libs-react-ts/src/configuration/publicPath'

import { bootstrap } from 'aem-libs-react-ts/src/inlet/bootstrap'

import { App } from './App'
import { APP_NAME } from './contants'
import './i18n'
import { initStore } from './store'
import type { ChildrenSavingsCalculatorParams } from './types'


bootstrap<ChildrenSavingsCalculatorParams>({
  appName: APP_NAME,
  AppComponent: App,
  options: {
    onFetchParams: initStore
  }
})
